import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { WarningCircle } from "@phosphor-icons/react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";

export default function Layout({ children, currentUser, billingInfo }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const showExpiredBanner = billingInfo?.has_org && !billingInfo?.is_active;

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen overflow-hidden bg-background/80 dark:bg-neutral-950">
      <Sidebar currentUser={currentUser} className="hidden lg:flex lg:w-64" />
      <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
        <SheetContent side="left" className="w-[300px] max-w-[85vw] border-r border-border/80 bg-white/95 p-0 backdrop-blur-xl dark:border-white/10 dark:bg-neutral-950/95">
          <SheetTitle className="sr-only">Navigation</SheetTitle>
          <Sidebar currentUser={currentUser} className="flex h-full w-full" onNavigate={() => setSidebarOpen(false)} />
        </SheetContent>
      </Sheet>
      <div className="flex-1 flex flex-col overflow-hidden">
        {showExpiredBanner && (
          <div className="flex flex-shrink-0 flex-col gap-2 border-b border-black/6 bg-destructive px-4 py-2 sm:flex-row sm:items-center sm:justify-between" data-testid="expired-banner">
            <div className="flex items-center gap-2 text-xs font-medium text-white">
              <WarningCircle weight="bold" className="w-4 h-4" />
              <span>Your subscription has expired. Subscribe to continue using UteFlow.</span>
            </div>
            <button onClick={() => navigate("/billing")}
              className="h-7 rounded-md bg-white px-3 text-xs font-bold text-destructive transition-colors hover:bg-red-50">
              Subscribe
            </button>
          </div>
        )}
        <Topbar currentUser={currentUser} billingInfo={billingInfo} onOpenSidebar={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6">{children}</main>
      </div>
    </div>
  );
}
